/* ADHDROOM article page (sections/adr-article.liquid):
   - the thin lime line at the top that fills up as you read;
   - the "In this article" jump list follows the part you're reading (and the phone version closes after a tap);
   - Share: the phone's own share sheet when there is one, and "Copy link";
   - ADHD-friendly reading: the start of each word in the text is bold, to guide the eyes. On by default; the switch
     above the article turns it off and the choice is remembered. Search engines get the plain text. */
(function () {
  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  function copyText(text, done) {
    var old = function () {
      var box = document.createElement('textarea');
      box.value = text;
      box.setAttribute('readonly', '');
      box.style.position = 'fixed';
      box.style.opacity = '0';
      document.body.appendChild(box);
      box.select();
      try { if (document.execCommand('copy')) done(); } catch (err) {}
      box.remove();
    };
    if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(text).then(done, old);
    else old();
  }

  ready(function () {
    var body = document.querySelector('[data-ar-body]');

    // ---------- ADHD-friendly reading ----------
    // Bold: 1 letter of words up to 3 letters, 2 of 4-letter words, then half the word. Latin letters only (Arabic and
    // the like join their letters, so they're left alone); headings, code and buttons are left as they are.
    var fxBtn = document.querySelector('[data-ar-fx]');
    if (body && fxBtn) {
      var fxKey = 'adr-reading-fx';
      var fxWord = /[A-Za-z\u00C0-\u024F]+(?:['\u2019][A-Za-z\u00C0-\u024F]+)*/g;
      var fxSkip = 'h1,h2,h3,h4,h5,h6,code,pre,kbd,samp,script,style,svg,button,select,textarea,b.fx';
      var fxOn = function () {
        var walker = document.createTreeWalker(body, NodeFilter.SHOW_TEXT, null);
        var nodes = [];
        while (walker.nextNode()) {
          var t = walker.currentNode;
          if (t.nodeValue.trim() && t.parentElement && !t.parentElement.closest(fxSkip)) nodes.push(t);
        }
        nodes.forEach(function (node) {
          var text = node.nodeValue;
          var frag = document.createDocumentFragment();
          var last = 0;
          var m;
          fxWord.lastIndex = 0;
          while ((m = fxWord.exec(text))) {
            var w = m[0];
            var letters = w.replace(/['\u2019]/g, '').length;
            var want = letters <= 3 ? 1 : (letters === 4 ? 2 : Math.ceil(letters / 2));
            var cut = 0;
            var seen = 0;
            while (cut < w.length && seen < want) {
              if (w[cut] !== "'" && w[cut] !== '\u2019') seen++;
              cut++;
            }
            if (m.index > last) frag.appendChild(document.createTextNode(text.slice(last, m.index)));
            var b = document.createElement('b');
            b.className = 'fx';
            b.textContent = w.slice(0, cut);
            frag.appendChild(b);
            if (cut < w.length) frag.appendChild(document.createTextNode(w.slice(cut)));
            last = m.index + w.length;
          }
          if (!last) return;
          if (last < text.length) frag.appendChild(document.createTextNode(text.slice(last)));
          node.parentNode.replaceChild(frag, node);
        });
      };
      var fxOff = function () {
        body.querySelectorAll('b.fx').forEach(function (b) { b.replaceWith(document.createTextNode(b.textContent)); });
        body.normalize();
      };
      var fxSet = function (on, remember) {
        fxBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (on) fxOn(); else fxOff();
        if (remember) { try { localStorage.setItem(fxKey, on ? 'on' : 'off'); } catch (err) {} }
      };
      var fxSaved = null;
      try { fxSaved = localStorage.getItem(fxKey); } catch (err) {}
      var fxBot = /bot|crawl|spider|slurp|lighthouse|inspectiontool/i.test(navigator.userAgent);
      fxSet(fxSaved !== 'off' && !fxBot, false);
      fxBtn.addEventListener('click', function () { fxSet(fxBtn.getAttribute('aria-pressed') !== 'true', true); });
    }

    // ---------- Reading line ----------
    var line = document.querySelector('[data-ar-progress] i');
    if (body && line) {
      var ticking = false;
      var update = function () {
        ticking = false;
        var r = body.getBoundingClientRect();
        var total = Math.max(1, r.height - window.innerHeight * 0.5);
        var done = Math.min(1, Math.max(0, (window.innerHeight * 0.3 - r.top) / total));
        line.style.transform = 'scaleX(' + done.toFixed(4) + ')';
      };
      window.addEventListener('scroll', function () {
        if (!ticking) { ticking = true; requestAnimationFrame(update); }
      }, { passive: true });
      window.addEventListener('resize', update);
      update();
    }

    // ---------- Jump list ----------
    // the part you're reading = the last heading that has passed the top third of the screen
    var links = document.querySelectorAll('[data-ar-toc] a');
    if (links.length) {
      var heads = [];
      links.forEach(function (a) {
        var h = document.getElementById(decodeURIComponent(a.getAttribute('href').slice(1)));
        if (h && heads.indexOf(h) < 0) heads.push(h);
      });
      var current = '';
      var waiting = false;
      var follow = function () {
        waiting = false;
        var line = window.innerHeight * 0.3;
        var id = '';
        heads.forEach(function (h) { if (h.getBoundingClientRect().top <= line) id = h.id; });
        if (id === current) return;
        current = id;
        links.forEach(function (a) { a.classList.toggle('is-on', !!id && a.getAttribute('href') === '#' + id); });
      };
      window.addEventListener('scroll', function () {
        if (!waiting) { waiting = true; requestAnimationFrame(follow); }
      }, { passive: true });
      follow();
    }
    document.querySelectorAll('.ar-main > details[data-ar-toc]').forEach(function (d) {
      d.addEventListener('click', function (e) { if (e.target.closest('a')) d.open = false; });
    });

    // ---------- Share ----------
    var native = document.querySelector('[data-ar-native]');
    if (native && navigator.share) {
      native.hidden = false;
      native.addEventListener('click', function () {
        navigator.share({ title: document.title, url: native.getAttribute('data-url') }).catch(function () {});
      });
    }
    document.querySelectorAll('[data-ar-copy]').forEach(function (btn) {
      var label = btn.querySelector('[data-ar-copy-label]');
      var idle = label ? label.textContent : '';
      var timer;
      btn.addEventListener('click', function () {
        copyText(btn.getAttribute('data-url'), function () {
          if (!label) return;
          label.textContent = btn.getAttribute('data-copied') || 'Copied';
          clearTimeout(timer);
          timer = setTimeout(function () { label.textContent = idle; }, 2000);
        });
      });
    });
  });
})();
